<template>
  <div class="productCenterContent1">
    <div class="left-margin">

    </div>
    <div class="center-content">
      <div class="center-top">
        <div class="right-product">
          <img src="../../assets/img/cpzx-top.png" >
        </div>
        <div class="left-product">
          <span>天鸿产品中心</span>
          <p>从网络、服务器和存储等IT基础设备，基础软件，应用软件和安全防护软硬件等全领域，天鸿在线提供完善的产品体系，为用户提供一站式产品与服务，助力客户推进信息化建设健康、科学发展。</p>
        </div>
      </div>
      <div class="center-center">
        <div class="product-content" v-for="item of productDetails" :key="item.goodsId">
          <div class="left">
            <img :src="item.image" width="60%" >
          </div>
          <div class="right">
            <div class="div-content">
              <h2>{{item.title}}</h2>
              <h4>{{item.subtitle1}}</h4>
              <span>{{item.content1}}</span>
              <h4>{{item.subtitle2}}</h4>
              <span>{{item.content2}}</span>
              <p>{{item.content3}}</p>
              <p>{{item.content4}}</p>
              <router-link :to="{path:'compProduct',query:{num:item.goodsId}}">
                <p class="word1-span">了解详细方案></p>
              </router-link>
            </div>
          </div>
        </div>


      </div>

    </div>
    <div class="right-margin">

    </div>


  </div>
</template>

<script>
  export default {
    data(){
      return {
        productDetails:[
          {
            goodsId:0,
            image:require("../../assets/img/zhyw.png"),
            title:"综合运维管理系统",
            subtitle1:"应用领域或场景:",
            content1:"适用于中大型企事业单位IT运维管理、设备运维管理和信息系统运维管理等场景。",
            subtitle2:"产品概述:",
            content2:"符合ITIL体系的实用的运维管理体系,主体功能包括:设备管理、事件管理、告警、自动化监控和统计分析等功能。"
          },
          {
            goodsId:1,
            image:require("../../assets/img/wlwwg.png"),
            title:"物联网网关",
            subtitle1:"应用领域或场景:",
            content1:"涉及物联设备监控及管理的场景。",
            subtitle2:"产品概述:",
            content2:"物联网关设备,支持485、232、Net、4G/5G、NB-IOT和Lora等主流物流通讯协议,可管理门禁、道闸、梯控、温感、烟感、摄像头和数据广播等物联设备。支持依据实际场景定制对接接口数量。标准REST API管理接口。"
          },
          {
            goodsId:2,
            image:require("../../assets/img/wlw.png"),
            title:"物联网综合管理平台",
            subtitle1:"应用领域或场景:",
            content1:"涉及管理、监控大量物联网关、物联设备的场景。",
            subtitle2:"产品概述:",
            content2:"集中、统一管理物联网关、物联设备的平台软件。主体功能包括物联网关注册、管理，物联设备注册、管理，同时对外提供物联监控和管理标准服务接口。",
          },
          {
            goodsId:3,
            image:require("../../assets/img/yyjc.png"),
            title:"应用集成管理平台",
            subtitle1:"应用领域或场景:",
            content1:"适用于需要对多个业务系统、智能化系统的综合管理或协同作业场景。",
            subtitle2:"产品概述:",
            content2:"子系统综合管理平台,第三方系统快速集成平台,主体功能包括:",
            content3:"1、应用注册、子系统或第三方系统的登记。",
            content4:"2、应用检测,监测子系统或第三方系统的运行状态。"
          },
          {
            goodsId:4,
            image:require("../../assets/img/sjzt.png"),
            title:"数据中台",
            subtitle1:"应用领域或场景:",
            content1:"适用于期望构建数据资产，集中管理数据，统一提供数据服务，深度开发应用数据的中大型信息化需求场景。",
            subtitle2:"产品概述:",
            content2:"全量采集数据,资产化管理数据,定制化开发数据应用的大数据管理平台,核心功能包括:",
            content3:"1、数据采集工具,内置ETL工具,调度式自动化采集数据。",
            content4:"2、数据清洗,模板定制当时清理数据。"
          }
        ]
      }
    }
  }

</script>

<style lang="less">
  .word1-span{
    	font-family: SourceHanSansCN-Light;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #009bff !important;
  cursor: pointer;
  }
  .productCenterContent1{
    display: flex;
    border-top-left-radius: 0.1rem;
    border-top-right-radius: 0.1rem;
    .left-margin{
      flex: 0.23;
    }
    .center-content{
      flex: 3;
      .center-top{
        display: flex;
        .right-product{
          flex: 2;
          img{
                width: 58%;
                margin-top: -0.2rem;
                margin-left: 1rem;
          }
        }
        .left-product{
          flex: 3;
          text-align: center;
          padding-top: 4%;
          padding-right: 0.7rem;
            span{
              font-size: 30px;

              	font-family: SourceHanSansCN-Medium;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;
            }
            p{
              text-align: left;
              margin-top: 0.1rem;
              	font-family: MicrosoftYaHeiLight;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;
            }
        }
      }
      .center-center{
        width: 100%;
        background: #FFFFFF;
        border-top-left-radius: 0.1rem;
        border-top-right-radius: 0.1rem;
        .product-content{
          display: flex;
          border-bottom: 0.1px solid #d6d6d6;
          .left{
            flex: 1.83;
            img{
              margin: 0.8rem 1rem;
            }
          }
          .right{
            flex: 3;
            display: flex;
            align-items: center;
            .div-content{
             // margin-top: 0.7rem;
              margin-right: 1rem;
              h2{
                	font-family: SourceHanSansCN-Regular;
              font-weight: bold;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #293347;
              }
              h4{
                margin-top: 0.1rem;
                margin-bottom: 0.1rem;

                    font-family: SourceHanSansCN-Regular;
                font-weight: bold;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #46506b;
              }
              span{
                	font-family: SourceHanSansCN-Light;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #636d8b;
              }
              p{
                margin-top: 0.1rem;
                	font-family: SourceHanSansCN-Light;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #636d8b;
              }
            }
          }
        }
      }
    }
    .right-margin{
      flex: 0.23;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/product-center-contet/ProductCenterContent1.vue